import { controls,grouped } from "../controls";
const query_group_datas = {
label: "Query Group Datas",
pageLabel: "Query Group Datas",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Report Field Type"}),
...controls.oc({ tab: "filter", c: "ReportFieldType", placeHolder: "Report Field Type Code", name: "QueryGroupData-report_field_type-report_field_type_code",fastpath:"report_field_types"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "QueryGroupData-report_field_type-report_field_type_display"}),
...controls.displayText({ tab: "filter", label: "Query Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "query_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Title"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "title",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Code"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "query_group_data_code",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Inputs"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "inputs",maxlength:20}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Seqno"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "seqno",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Keycol"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "keycol",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Comparator Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "comparator_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Compare With"}),
...controls.text({ tab: "filter",  placeHolder: "", name: "compare_with",maxlength:50}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Css Style Id"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "css_style_id",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Report Field Type",star:true}),
...controls.oc({ tab: "general", c: "ReportFieldType", placeHolder: "Report Field Type Code", name: "report_field_type_code", isRequired:true,fastpath:"report_field_types"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "report_field_type_display"}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-6",parents:[{"name": "report_field_type_code", "match": "in", "value": ["", "3"]}]}),
...controls.displayText({ tab: "general", label: "Query",star:false,parents:[{"name": "report_field_type_code", "match": "in", "value": ["2"]}]}),
...controls.oc({ tab: "general", c: "Query", placeHolder: "Query Code", name: "query_code", isRequired:false,fastpath:"queries",parents:[{"name": "report_field_type_code", "match": "in", "value": ["2"]}]}),
...controls.showData({ tab: "general", displaytype: "capital", data: "query_display",parents:[{"name": "report_field_type_code", "match": "in", "value": ["2"]}]}),
...controls.displayText({ tab: "general", label: "Title",star:false,parents:[{"name": "report_field_type_code", "match": "in", "value": ["1"]}]}),
...controls.text({ tab: "general",  placeHolder: "", name: "title",isRequired:false,maxlength:50,parents:[{"name": "report_field_type_code", "match": "in", "value": ["1"]}]}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2",parents:[{"name": "report_field_type_code", "match": "in", "value": ["1"]}]}),
...controls.displayText({ tab: "general", label: "Code",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "query_group_data_code",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Inputs",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "inputs",isRequired:false,maxlength:20}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Seqno",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "seqno",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Keycol",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "keycol",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Comparator",star:false}),
...controls.oc({ tab: "general", c: "Comparator", placeHolder: "Comparator Code", name: "comparator_code", isRequired:false,fastpath:"comparators"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "comparator_display"}),
...controls.displayText({ tab: "general", label: "Compare With",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "compare_with",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Css Style",star:false}),
...controls.oc({ tab: "general", c: "CSSStyle", placeHolder: "Css Style Code", name: "css_style_code", isRequired:false,fastpath:"css_styles"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "css_style_display"}),
]
,history:{
perPage: 10,
reportHeader: "Query Group Datas",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Report Field Type Id",accessor: "report_field_type_id",},
{Header: "Query Id",accessor: "query_id",},
{Header: "Title",accessor: "title",},
{Header: "Query Group Data Code",accessor: "query_group_data_code",},
{Header: "Inputs",accessor: "inputs",},
{Header: "Seqno",accessor: "seqno",},
{Header: "Keycol",accessor: "keycol",},
{Header: "Comparator Id",accessor: "comparator_id",},
{Header: "Compare With",accessor: "compare_with",},
{Header: "Css Style Id",accessor: "css_style_id",},
]}};
export default query_group_datas;